import { Table } from "antd";
import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { deudasService } from "../../../../_services/deudas.service";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { v4 as uuidv4 } from "uuid";
import LoadingModal from "../../../../components/LoadingModal/LoadingModal";
import { useUser } from "../../../../hooks/useUser";
import { RecursosComercios } from "../../../../constants";
import { inmuebleService } from "../../../../_services/inmuebles.service";


const columns = [
  {
    title: "Imponible",
    dataIndex: "imponible",
    key: "imponible",
  },
  {
    title: "Recurso",
    dataIndex: "recurso",
    key: "recurso",
  },
  {
    title: "Contribuyente",
    dataIndex: "contribuyente",
    key: "contribuyente",
  },
  {
    title: "Accion",
    dataIndex: "accion",
    key: "accion",
  },
];

// const Recursos = {
//   "19": "19",
//   "SE": "SE",
//   "SH": "SH",
//   "PP": "PP",
//   "2": "2",
//   "EP": "EP",
//   "9": "9",
//   "SV": "SV",
//   "LO": "LO",
//   "SA": "SA",
//   "DI": "DI",
//   "IV": "IV"
// };


const BuscarDeudas = ({ deudas, setDeudas, handleRemove, convenio, planes = [], comercios }) => {
  const user = useUser();
  const [values, setValues] = useState({
    inmueble: "",
    recurso: "",
    nombre: "",
  });

  const [loading, setLoading] = useState(false);

  const checkLegal = (legal) => {
    let result = legal?.filter(e => e.LEGAL === user.abogado || user.abogado === "A00");

    return result;
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      let response = await deudasService.getDeuda({
        recurso: convenio.recurso,
        imponible: convenio.imponible
      });

      setDeudas([{ ...response.data, legal: checkLegal(response.data?.legal), recurso: values.recurso, uuid: uuidv4() }]);
      setLoading(false);
    };

    if (convenio) {
      getData();
    }
  }, [convenio]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const resDeudas = [];

      // Itera sobre las URLs y realiza las solicitudes secuenciales
      for (const e of planes) {
        const resDeuda = await deudasService.getDeuda({
          imponible: e.imponible,
          recurso: e.recurso
        });

        if (resDeuda?.data?.mensaje) {
          continue;
        }
        else {
          if (resDeuda.data?.legal?.length && !checkLegal(resDeuda.data?.legal)?.length) {
            continue;
          }
          else {
            resDeudas.push({ ...resDeuda, recurso: e.recurso });
            continue;
          }
        }
      }

      if (resDeudas?.filter(e => e).length) {
        resDeudas?.forEach((response) => {
          setDeudas((prev) => {
            if (response.data) {
              if (prev?.length) {
                if (prev.some(p => p.recurso === response.recurso && p.imponible === response.data.imponible)) {
                  return prev;
                }
                else {
                  return [...prev, { ...response.data, legal: checkLegal(response.data?.legal), recurso: response.recurso, uuid: uuidv4() }];
                }
              }
              else {
                return [{ ...response.data, legal: checkLegal(response.data?.legal), recurso: response.recurso, uuid: uuidv4() }];
              }
            }
            else {
              return [];
            }
          });
        });

        setLoading(false);
      }

      setLoading(false);
    };

    if (planes?.length) {
      getData();
    }
  }, [planes]);

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    });
  };

  const handleSearch = async () => {
    try {
      setLoading(true);

      let data = values;

      for (const value in data) {
        if (!data[value]) {
          delete data[value];
        }
      }

      if (data.nombre) {
        data.nombre = data.nombre.toUpperCase();
      }

      if (user.rol === "user") {
        data.abogado = user.abogado;
      }

      setValues({
        recurso: "",
        inmueble: "",
        nombre: "",
      });

      const resDeudas = [];

      if (comercios) {
        const nroComercios = [];
        if (data.cc) {
          const resDeuda = await deudasService.comercioxCC(data.cc);
          resDeuda.data.data.forEach((c) => {
            if (!nroComercios.some((n) => n === c.NRO_COMERCIO)) {
              nroComercios.push(c.NRO_COMERCIO);
            }
          });
        }
        if (data.nro_comercio) {
          nroComercios.push(data.nro_comercio);
        }

        for (const comercio of nroComercios) {
          for (const recurso of RecursosComercios) {
            const resDeuda = await deudasService.getDeuda({
              imponible: comercio,
              recurso
            });

            if (resDeuda?.data?.mensaje) {
              continue;
            }
            else {
              if (!resDeuda?.data?.legal?.length) {
                continue;
              }
              if (resDeuda.data?.legal?.length && (resDeuda.data.legal[resDeuda.data.legal.length - 1].LEGAL !== user.abogado && user.abogado !== "A00")) {
                continue;
              }
              else {
                resDeudas.push({ ...resDeuda, recurso });
                continue;
              }
            }
          }
        }
      }
      else {
        let response;

        if (data.inmueble && data.recurso) {
          response = await deudasService.listaSitua({
            imponible: data.inmueble,
            recurso: data.recurso,
          }).then(res => {
            if (res.situacion?.length) {
              return res.situacion.reduce((prev, current) => {
                if (prev.some(e => e.NRO_IMPONIBLE === current.NRO_IMPONIBLE)) {
                  return prev;
                } else {
                  return [...prev, current];
                }
              }, []);
            } else {
              return [];
            }
          });
        } else {
          response = await inmuebleService.getInmuebles(data);
          // if (!data.inmueble || !data.recurso) {
          //   setLoading(false);
          //   return Swal.fire(
          //     "Debe completar un inmueble y recurso.",
          //     "",
          //     "warning"
          //   );
          // }
        }

        if (response?.length) {
          // // Itera sobre las URLs y realiza las solicitudes secuenciales
          for (const e of response) {
            const resDeuda = await deudasService.getDeuda({
              imponible: e.NRO_IMPONIBLE || e.NRO_INMUEBLE,
              recurso: e.RECURSO
            });

            if (resDeuda?.data?.mensaje) {
              continue;
            }
            else {
              if (resDeuda.data?.legal?.length && !checkLegal(resDeuda.data?.legal)?.length) {
                continue;
              }
              else {
                resDeudas.push({ ...resDeuda, recurso: e.RECURSO });
                continue;
              }
            }
          }
        }
      }

      if (resDeudas?.filter(e => e).length) {
        resDeudas?.forEach((response) => {
          setDeudas((prev) => {
            if (response.data) {
              if (prev?.length) {
                if (prev.some(p => p.recurso === response.recurso && p.imponible === response.data.imponible)) {
                  return prev;
                }
                else {
                  return [...prev, { ...response.data, legal: checkLegal(response.data?.legal), recurso: response.recurso, uuid: uuidv4() }];
                }
              }
              else {
                return [{ ...response.data, legal: checkLegal(response.data?.legal), recurso: response.recurso, uuid: uuidv4() }];
              }
            }
            else {
              return [];
            }
          });
        });
      }
      setLoading(false);
    }
    catch (err) {
      setLoading(false);
      console.log("handleSearch", err);
    }
  };

  const formatData = (data) => {
    try {
      if (!data) return [];

      return data.map(item => {
        const { contribuyente } = item;

        return {
          ...item,
          contribuyente: contribuyente?.APYNOM,
          accion: (
            <div className="d-flex">
              <Button
                className="d-flex align-items-center"
                onClick={() => handleRemove(item)}
                variant="light"
                style={{ borderColor: "lightgray" }}
              >
                <FontAwesomeIcon title="Remover Convenio" icon={faTrash} color="red" size="lg" />
              </Button>
            </div>
          )
        };
      });
    }
    catch (err) {
      console.log("formatData", err);
      return [];
    }
  };

  return (
    <div>
      <div className="p-3">
        <Row>
          <Col sm={12} md={12}>
            <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 20 }}>
              Buscar deudas
            </div>
          </Col>
        </Row>
        {comercios ? (
          <Row>
            <Col sm={6} md={6}>
              <Form.Label className="label" >NRO DE COMERCIO:</Form.Label>
              <Form.Control
                name="nro_comercio"
                onChange={handleChange}
                value={values.nro_comercio}
              />
            </Col>
            <Col sm={6} md={6}>
              <Form.Label className="label" >CUIT:</Form.Label>
              <Form.Control
                name="cc"
                onChange={handleChange}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col sm={4} md={4}>
              <Form.Label className="label" >IMPONIBLE:</Form.Label>
              <Form.Control
                name="inmueble"
                onChange={handleChange}
                value={values.inmueble}
              />
            </Col>
            <Col sm={4} md={4}>
              <Form.Label className="label" >RECURSO:</Form.Label>
              <Form.Control
                name="recurso"
                onChange={handleChange}
                value={values.recurso}
              />
            </Col>
            <Col sm={4} md={4}>
              <Form.Label className="label" >CONTRIBUYENTE:</Form.Label>
              <Form.Control
                name="nombre"
                onChange={handleChange}
                value={values.nombre}
              />
            </Col>
          </Row>
        )}
        <div className="d-flex justify-content-center mt-4 mb-3">
          <Button onClick={handleSearch}>{deudas?.length ? "Agregar" : "Buscar"}</Button>
        </div>
      </div>
      <div style={{ overflow: "auto" }}>
        <Table dataSource={formatData(deudas)} columns={columns} rowKey="uuid" />
      </div>

      {loading ? <LoadingModal show={loading} loading={true} /> : null}
    </div>
  );
};

export default BuscarDeudas;